/* eslint-disable react/no-danger */
/* eslint-disable react/prop-types */
// import { PropTypes } from "prop-types";

import React, { useState } from "react";
import { graphql } from "gatsby";
import Img from "gatsby-image";
import Footer from "~components/Footer";
import Layout from "~components/Layout";
import SEO from "~components/SEO";

const FaqsPage = ({ data, location }) => {
  const [expanded, setExpanded] = useState(null);

  const { frontmatter } = data.markdownRemark;

  //

  return (
    <>
      <SEO
        customTitle={frontmatter.title}
        customDescription={frontmatter.seoDescription}
        customKeywords={frontmatter.seoKeywords}
        path={location.pathname}
      />

      <Layout className="faqs-page w-full relative pt-24 md:pt-48 bg-cream text-dark-green">
        <section className="grid">
          <article className="grid-end-12 sm:grid-end-10 md:grid-end-8 sm:grid-start-2 md:grid-start-3">
            <h1 className="animation-appear-down-slow animation-delay-1 mt-10 mb-12 f2 text-center">
              {frontmatter.title}
            </h1>

            {(frontmatter?.image?.childImageSharp?.fluid && (
              <Img
                className="animation-appear-down-slow animation-delay-2 w-2/3 relative block mx-auto"
                fluid={frontmatter.image.childImageSharp.fluid}
                alt={frontmatter.imageAlt}
              />
            )) || (
              <>
                {frontmatter?.image?.publicURL && (
                  <img
                    className="animation-appear-down-slow animation-delay-2 w-4/5 sm:w-1/2 relative block mx-auto"
                    src={frontmatter.image.publicURL}
                    alt={frontmatter.imageAlt}
                  />
                )}
              </>
            )}

            <div className="animation-appear-down-slow animation-delay-3 w-full relative block mt-12">
              {frontmatter.questions.map((question, questionIndex) => {
                const questionKey = `faq-question-${questionIndex}`;
                const isExpanded = expanded === questionIndex;

                let id = questionKey;

                if (question?.scrollId !== ``) {
                  id = `faq-${question.scrollId}`;
                }

                return (
                  <article
                    id={id}
                    key={questionKey}
                    className="faqs-page__article w-full relative block"
                  >
                    <button
                      type="button"
                      className="w-full relative block cursor-pointer f5 text-center text-orange"
                      onClick={() =>
                        setExpanded(isExpanded ? null : questionIndex)
                      }
                    >
                      <span className="block pt-4 pb-4">
                        {question.question}
                        {` `}
                        {isExpanded ? `-` : `+`}
                      </span>
                    </button>

                    {isExpanded && (
                      <div
                        className="animation-appear-down-slow animation-delay-1 mt-4 mb-12 b1 text-left"
                        dangerouslySetInnerHTML={{ __html: question.answer }}
                      ></div>
                    )}

                    <img
                      className="w-full relative block"
                      src="/uploads/squiggle-md.svg"
                      alt="Orange squiggle"
                    />
                  </article>
                );
              })}
            </div>
          </article>

          <article
            id="faq-sustainability"
            className="faqs-page__article grid-end-12 sm:grid-end-10 md:grid-end-8 sm:grid-start-2 md:grid-start-3 relative block mb-32 sm:mb-20 md:mb-32"
          >
            <br />
            <br />
            <h4 className="mb-4 f4 text-center">
              {frontmatter.footnoteHeading}
            </h4>

            <div
              className="relative"
              dangerouslySetInnerHTML={{ __html: frontmatter.footnoteContent }}
            ></div>
          </article>
        </section>

        <Footer />
      </Layout>
    </>
  );
};

export default FaqsPage;

export const query = graphql`
  query FaqsPage($id: String!) {
    markdownRemark(id: { eq: $id }) {
      frontmatter {
        title
        image {
          childImageSharp {
            fluid(maxWidth: 512, quality: 75) {
              ...GatsbyImageSharpFluid_withWebp_noBase64
            }
          }
          publicURL
        }
        imageAlt
        questions {
          question
          answer
          scrollId
        }
        footnoteHeading
        footnoteContent
        seoDescription
        seoKeywords
      }
    }
  }
`;
